import { FormControl, FormField, FormInput, FormItem, FormLabel, FormMessage, RadioGroup, RadioGroupItem, Text } from "@sentricmusic/ui";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import type { GigClaimFormValues } from "../utils/gigsClaimSchema";

function FestivalSection() {
  const { t } = useTranslation(["gigs"]);
  const { control } = useFormContext<GigClaimFormValues>();

  return (
    <div>
      <Text as="subtitle">{t("gigs:festival-header", "Festival")}</Text>
      <div className="flex flex-col gap-2">
        <FormField
          control={control}
          name="festivalStageName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("gigs:stage-name", "Stage Name")}</FormLabel>
              <FormControl>
                <FormInput
                  placeholder={t("gigs:stage-name", "Stage Name") ?? "Stage Name"}
                  {...field}
                  value={field.value ?? ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="festivalPosition"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("gigs:position-on-stage", "Position on Stage")}</FormLabel>
              <FormControl>
                <RadioGroup
                  value={field.value ?? ""}
                  onValueChange={field.onChange}
                  className="flex flex-row gap-4"
                >
                  <RadioGroupItem id="festivalPosition-headline" value="headline" />
                  <label htmlFor="festivalPosition-headline" className="text-sm font-sentric-alt cursor-pointer">
                    {t("gigs:headline-artist", "Headline artist")}
                  </label>
                  <RadioGroupItem id="festivalPosition-support" value="support" />
                  <label htmlFor="festivalPosition-support" className="text-sm font-sentric-alt cursor-pointer">
                    {t("gigs:support-artist", "Support artist")}
                  </label>
                </RadioGroup>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}

export default FestivalSection;
